export const coordinatesCardStyles =
   'absolute top-[10px] left-[10px] p-4 !rounded-xl w-[320px] border !border-solid'

export const infoCardStyles =
   'absolute left-[126px] bottom-[24px] w-fit max-w-[518px] px-4 py-[10px]'

export const currentLocationButtonStyles =
   '!absolute left-1/2 bottom-6 -translate-x-1/2'

export const actionButtonsContainerStyles =
   '!absolute right-6 bottom-6 flex items-center gap-2'

export const inputContainerStyles =
   '!border-none !shadow-none !outline-none !p-0 rounded-none flex-1 min-w-0 !bg-base-white'

export const coordinateInputContainerStyles =
   'rounded-xl border flex-col gap-3 flex flex-1 min-w-0 px-2 py-0'

export const mobileCoordinatesCardStyles =
   'absolute top-4 left-3 right-3 p-3 !rounded-xl border !border-solid'

export const subContainerStyles =
   'p-4 rounded-xl border overflow-y-auto scrollbar h-full border-gray-300 bg-base-white'

export const getMobileToggleHeaderStyles = (isMobile: boolean): string =>
   `flex justify-between items-center ${
      isMobile ? 'text-sm-medium' : 'text-md-medium'
   } text-gray-700`

export const getContainerStyles = (isMobile: boolean): string =>
   `flex flex-col relative ${isMobile ? 'w-[calc(100%-16px)]' : 'w-[440px]'}`

export const markerNumberStyles =
   'text-xs-medium absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2'

export const sectionEnhancerStyles =
   'h-24px w-3px border-rounded-16px absolute -left-20px bg-primary-600 rounded-r'

export const inputStyles = 'geo-location min-w-0 !bg-base-white py-2'
